/**
 * 目前eventType 仅支持`click`和`exposure`两种
 */

export default {
  // 登录
  LOGIN_PAGE_EXPOSURE: {
    eventType: 'exposure',
  },
  LOGIN_LOGIN_BUTTON_CLICK: {
    eventType: 'click',
  },
  LOGIN_WECHAT_BUTTON_CLICK: {
    eventType: 'click',
  },

  // 注册
  REGISTER_PAGE_EXPOSURE: {
    eventType: 'exposure',
  },
  REGISTER_CODE_BUTTON_CLICK: {
    eventType: 'click',
  },
  REGISTER_LOGON_BUTTON_CLICK: {
    eventType: 'click',
  },
  REGISTER_WECHAT_BUTTON_CLICK: {
    eventType: 'click',
  },

  // 支付弹窗
  PAY_POPUP_EXPOSURE: {
    eventType: 'exposure',
  },
  PAY_POPUP_CLOSE: {
    eventType: 'click',
  },
  PAY_BUTTON_CLICK: {
    eventType: 'click',
  },
  PAY_POPUP_COUPON_BUTTON_CLICK: {
    eventType: 'click',
  },
  PAY_POPUP_PAY_BUTTON_CLICK: {
    eventType: 'click',
  },
  PAY_POPUP_PAY_SUCCESS: {
    eventType: 'functional',
  },
  PAY_POPUP_PAY_FAILURE: {
    eventType: 'functional',
  },
  PAY_POPUP_PAY_CANCEL: {
    eventType: 'functional',
  },

  // 收银台
  PAY_FORM_EXPOSURE: {
    eventType: 'exposure',
  },
  PAY_FORM_CLOSE: {
    eventType: 'click',
  },
  PAY_FORM_COUPON_BUTTON_CLICK: {
    eventType: 'click',
  },
  PAY_FORM_PAY_BUTTON_CLICK: {
    eventType: 'click',
  },
  PAY_FORM_PAY_SUCCESS: {
    eventType: 'functional',
  },
  PAY_FORM_PAY_FAILURE: {
    eventType: 'functional',
  },
  PAY_FORM_PAY_CANCEL: {
    eventType: 'functional',
  },

  // 首页
  MAIN_BANNER_CLICK: {
    eventType: 'click',
  },
  MAIN_BANNER_EXPOSURE: {
    eventType: 'exposure',
  },
  MAIN_MAIN_ENTRY_CLICK: {
    eventType: 'click',
  },
  MAIN_COLLEGE_ENTRY_CLICK: {
    eventType: 'click',
  },
  MAIN_GET_GIFT_CLICK: {
    eventType: 'click',
  },
  MAIN_DAILY_AUDIO_CLICK: {
    eventType: 'click',
  },
  MAIN_DAILY_AUDIO_PLAY_CLICK: {
    eventType: 'click',
  },
  MAIN_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  MAIN_LIST_CLICK: {
    eventType: 'click',
  },
  MAIN_LARGE_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  MAIN_LARGE_GRID_CLICK: {
    eventType: 'click',
  },
  MAIN_SMALL_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  MAIN_SMALL_GRID_CLICK: {
    eventType: 'click',
  },
  MAIN_FULLSCREEN_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  MAIN_FULLSCREEN_GRID_CLICK: {
    eventType: 'click',
  },
  MAIN_CARD_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  MAIN_CARD_GRID_CLICK: {
    eventType: 'click',
  },

  // 音频
  AUDIO_BANNER_EXPOSURE: {
    eventType: 'exposure',
  },
  AUDIO_BANNER_CLICK: {
    eventType: 'click',
  },
  AUDIO_MAIN_ENTRY_CLICK: {
    eventType: 'click',
  },
  AUDIO_FREE_AUDIO_CLICK: {
    eventType: 'click',
  },
  AUDIO_GET_GIFT_CLICK: {
    eventType: 'click',
  },
  AUDIO_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  AUDIO_LIST_CLICK: {
    eventType: 'click',
  },
  AUDIO_LARGE_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  AUDIO_LARGE_GRID_CLICK: {
    eventType: 'click',
  },
  AUDIO_SMALL_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  AUDIO_SMALL_GRID_CLICK: {
    eventType: 'click',
  },
  AUDIO_FULLSCREEN_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  AUDIO_FULLSCREEN_GRID_CLICK: {
    eventType: 'click',
  },
  AUDIO_CARD_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  AUDIO_CARD_GRID_CLICK: {
    eventType: 'click',
  },

  // 课程
  COURSE_BANNER_EXPOSURE: {
    eventType: 'exposure',
  },
  COURSE_BANNER_CLICK: {
    eventType: 'click',
  },
  COURSE_MAIN_ENTRY_CLICK: {
    eventType: 'click',
  },
  COURSE_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  COURSE_LIST_CLICK: {
    eventType: 'click',
  },
  COURSE_LARGE_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  COURSE_LARGE_GRID_CLICK: {
    eventType: 'click',
  },
  COURSE_SMALL_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  COURSE_SMALL_GRID_CLICK: {
    eventType: 'click',
  },
  COURSE_FULLSCREEN_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  COURSE_FULLSCREEN_GRID_CLICK: {
    eventType: 'click',
  },
  COURSE_CARD_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  COURSE_CARD_GRID_CLICK: {
    eventType: 'click',
  },

  // 家长课堂
  PARENT_BANNER_EXPOSURE: {
    eventType: 'exposure',
  },
  PARENT_BANNER_CLICK: {
    eventType: 'click',
  },
  PARENT_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  PARENT_LIST_CLICK: {
    eventType: 'click',
  },
  PARENT_LARGE_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  PARENT_LARGE_GRID_CLICK: {
    eventType: 'click',
  },
  PARENT_SMALL_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  PARENT_SMALL_GRID_CLICK: {
    eventType: 'click',
  },
  PARENT_FULLSCREEN_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  PARENT_FULLSCREEN_GRID_CLICK: {
    eventType: 'click',
  },
  PARENT_CARD_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  PARENT_CARD_GRID_CLICK: {
    eventType: 'click',
  },

  // 学习模块
  LEARNING_INFO_SKIP_CLICK: {
    eventType: 'click',
  },
  LEARNING_INFO_STEP_1_CONFIRM_CLICK: {
    eventType: 'click',
  },
  LEARNING_INFO_STEP_2_CONFIRM_CLICK: {
    eventType: 'click',
  },
  LEARNING_INFO_STEP_3_CONFIRM_CLICK: {
    eventType: 'click',
  },
  LEARNING_MEDALS_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_CERTS_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_REPORTS_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_WORKS_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_AUDIO_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_COURSE_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_PROJECT_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_CHALLENGE_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_DOWNLOAD_ENTRY_CLICK: {
    eventType: 'click',
  },
  LEARNING_AUDIO_RECOMMEND_EXPOSURE: {
    eventType: 'exposure',
  },
  LEARNING_AUDIO_RECOMMEND_CLICK: {
    eventType: 'click',
  },
  LEARNING_COURSE_RECOMMEND_EXPOSURE: {
    eventType: 'exposure',
  },
  LEARNING_COURSE_RECOMMEND_CLICK: {
    eventType: 'click',
  },
  LEARNING_AUDIO_CLICK: {
    eventType: 'click',
  },
  LEARNING_AUDIO_PLAY_CLICK: {
    eventType: 'click',
  },
  LEARNING_COURSE_CLICK: {
    eventType: 'click',
  },
  LEARNING_VIP_ENTRY_CLICK: {
    eventType: 'click',
  },

  // 市场活动
  MARKETING_AD_MAIN_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_AD_MAIN_CLICK: {
    eventType: 'click',
  },
  MARKETING_AD_AUDIO_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_AD_AUDIO_CLICK: {
    eventType: 'click',
  },
  MARKETING_AD_ACTIVITY_POPUP_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_AD_ACTIVITY_POPUP_CLICK: {
    eventType: 'click',
  },

  // VIP相关
  MARKETING_VIP_BUY_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIP_AD_PAY_POPUP_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIP_AD_PRODUCT_DETAIL_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIP_AD_MY_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIP_AD_VIP_CENTER_CLICK: {
    eventType: 'click',
  },

  // 积分
  POINTS_ENTRY_CLICK: {
    eventType: 'click',
  },

  // 下载引导
  GROWTH_DOWNLOAD_APP_BAR_DOWNLOAD_CLICK: {
    eventType: 'click',
  },
  GROWTH_DOWNLOAD_APP_BAR_DOWNLOAD_CLOSE_CLICK: {
    eventType: 'click',
  },
  GROWTH_DOWNLOAD_APP_PAGE_DOWNLOAD_CLICK: {
    eventType: 'click',
  },
  GROWTH_AUDIO_DETAIL_OPEN_APP_CLICK: {
    eventType: 'click',
  },
  GROWTH_AUDIO_DETAIL_DOWNLOAD_AUDIO_CLICK: {
    eventType: 'click',
  },
  GROWTH_PROGRAM_DETAIL_DOWNLOAD_AUDIO_CLICK: {
    eventType: 'click',
  },
  GROWTH_AUDIO_DETAIL_DOWNLOAD_AUDIO_POPUP_DOWNLOAD_CLICK: {
    eventType: 'click',
  },

  // 秒杀产品列表按钮点击
  SECKILL_PRODUCT_BTN_CLICK: {
    eventType: 'click',
  },
  // 秒杀页面底部按钮点击
  SECKILL_HOME_BOTTOM_BTN_CLICK: {
    eventType: 'click',
  },
  // 秒杀弹窗按钮点击
  SECKILL_POPUP_BTN_CLICK: {
    eventType: 'click',
  },

  // 新人礼包
  NEW_USER_GIFT_CLICK: {
    eventType: 'click',
  },

  // 学员风采
  STUDENT_GAINS_BANNER_EXPOSURE: {
    eventType: 'exposure',
  },
  STUDENTGAINS_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  STUDENTGAINS_LARGE_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  STUDENTGAINS_SMALL_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  STUDENTGAINS_FULLSCREEN_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  STUDENTGAINS_CARD_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  STUDENTGAINS_LIST_CLICK: {
    eventType: 'click',
  },
  STUDENTGAINS_LARGE_GRID_CLICK: {
    eventType: 'click',
  },
  STUDENTGAINS_SMALL_GRID_CLICK: {
    eventType: 'click',
  },
  STUDENTGAINS_FULLSCREEN_GRID_CLICK: {
    eventType: 'click',
  },
  STUDENTGAINS_CARD_GRID_CLICK: {
    eventType: 'click',
  },

  // 聚合好课
  CUSTOMCOLLECTION_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  CUSTOMCOLLECTION_LARGE_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  CUSTOMCOLLECTION_SMALL_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  CUSTOMCOLLECTION_FULLSCREEN_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  CUSTOMCOLLECTION_CARD_GRID_EXPOSURE: {
    eventType: 'exposure',
  },
  CUSTOMCOLLECTION_LIST_CLICK: {
    eventType: 'click',
  },
  CUSTOMCOLLECTION_LARGE_GRID_CLICK: {
    eventType: 'click',
  },
  CUSTOMCOLLECTION_SMALL_GRID_CLICK: {
    eventType: 'click',
  },
  CUSTOMCOLLECTION_FULLSCREEN_GRID_CLICK: {
    eventType: 'click',
  },
  CUSTOMCOLLECTION_CARD_GRID_CLICK: {
    eventType: 'click',
  },

  // 部分购买套餐
  SUBSIDY_COUPON_CLICK: {
    eventType: 'click',
  },
  JOIN_GROUP_POPUP_EXPOSURE: {
    eventType: 'exposure',
  },
  JOIN_GROUP_JOINED_CLICK: {
    eventType: 'click',
  },
  JOIN_GROUP_MULTI_POPUP_EXPOSURE: {
    eventType: 'exposure',
  },
  JOIN_GROUP_MULTI_POPUP_CLOSE_CLICK: {
    eventType: 'click',
  },
  JOIN_GROUP_PROMPT_BTN_CLICK: {
    eventType: 'click',
  },
  OPEN_WECHAT_NOTICE_PROMPT_BTN_CLICK: {
    eventType: 'click',
  },
  CLASS_GUIDE_VIDEO_PLAY_CLICK: {
    eventType: 'click',
  },
  JOIN_GROUP_QRCODE_CLICK: {
    eventType: 'click',
  },

  // 百万阅读
  MILLION_VIP_NOTIFY_GUIDE_CLICK: {
    eventType: 'click',
  },
  MILLION_VIP_NOTIFY_GO_LEARNING_CLICK: {
    eventType: 'click',
  },
  EXCHANGE_RECORD_EXCHANGE_CLICK: {
    eventType: 'click',
  },
  EXCHANGE_ORDER_QUICK_EXCHANGE_CLICK: {
    eventType: 'click',
  },
  MILLION_VIP_WORKS_MINE_CLICK: {
    eventType: 'click',
  },
  USER_READING_INTEREST_SET_UP_CLICK: {
    eventType: 'click',
  },
  MILLION_VIP_USER_HOMEPAGE_ENTER_TOPIC_COMMENT_CLICK: {
    eventType: 'click',
  },
  MILLION_EXVIP_GET_SUCCESS: {
    eventType: 'click',
  },

  // 抖音新人礼包
  NEWGIFT2021_SWITCH_CLICK: {
    eventType: 'click',
  },
  NEWGIFT2021_GET_CODE_CLICK: {
    eventType: 'click',
  },
  NEWGIFT2021_GET_CLICK: {
    eventType: 'click',
  },
  NEWGIFT2021_GET_SUCCESS: {
    eventType: 'click',
  },
  NEWGIFT2021_SUCCESS_JUMP_CLICK: {
    eventType: 'click',
  },
  NEWGIFT2021_SUCCESS_SKIP_CLICK: {
    eventType: 'click',
  },

  // IAP 苹果充值
  PAY_CENTER_RECHARGE_EXPOSURE: {
    eventType: 'exposure',
  },
  PAY_CENTER_RECHARGE_CLICK: {
    eventType: 'click',
  },

  // 直播课详情改版
  COURSE_DETAIL_HELPCENTER_CLICK: {
    eventType: 'click',
  },
  COURSE_DETAIL_ATONCE_JOINVIP_CLICK: {
    eventType: 'click',
  },
  COURSE_DETAIL_ATONCE_BUYCOURSE_CLICK: {
    eventType: 'click',
  },
  COURSE_DETAIL_ABOUT_RECOMMEND_EXPOSURE: {
    eventType: 'exposure',
  },
  COURSE_DETAIL_ABOUT_RECOMMEND_CLICK: {
    eventType: 'click',
  },
  COURSE_DETAIL_AUDITION_CLICK: {
    eventType: 'click',
  },
  COURSE_DETAIL_COMMENTLIKE_CLICK: {
    eventType: 'click',
  },
  COURSE_DETAIL_COLLECTION_CLICK: {
    eventType: 'click',
  },
};
